import { MESSAGES } from '../actions/messages';

const defaultState = {
  list: [],
  count: 0,
  nextPage: 1,
  isLoaded: true,
};

export default (state = defaultState, { type, ...action }) => {
  switch (type) {
    case MESSAGES.LOAD:
      return { ...state, isLoaded: false };

    case MESSAGES.LOAD_DONE:
      return {
        ...state,
        nextPage: state.nextPage + 1,
        list: action.list.concat(state.list),
        count: action.count,
        isLoaded: true,
      };

    case MESSAGES.CHECKNEW_DONE:
      if (
        action.list.length
        && (
          !state.list.length
          // has new message:
          || state.list[state.list.length - 1].id !== action.list[action.list.length - 1].id
          // changed status:
          || state.list.slice(-1 * action.list.length).map(({ id, status }) => `${id}=${status}`).join(':')
            !== action.list.map(({ id, status }) => `${id}=${status}`).join(':')
        )
      ) {
        return {
          ...defaultState,
          nextPage: defaultState.nextPage + 1,
          list: action.list,
          count: action.count,
        };
      }
      return state;

    case MESSAGES.LOAD_FAILED:
      console.log(action.message);
      return { ...state, isLoaded: true };

    case MESSAGES.RESET:
      return defaultState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/messages.js